import { useSearchParams } from "react-router-dom";
import { Mail, Globe, Clock } from "lucide-react";
import PageHeader from "../components/PageHeader";
import Reveal from "../components/Reveal";
import EnquiryForm from "../components/EnquiryForm";
import { COMPANY } from "../data/content";

const Contact = () => {
  const [searchParams] = useSearchParams();
  const intent = searchParams.get("intent");
  const isConsultation = intent === "consultation" || intent === "project";

  return (
    <main data-testid="contact-page">
      <PageHeader
        eyebrow="Get in Touch"
        title={isConsultation ? "Schedule a Consultation" : "Contact Us"}
        description="Tell us about your business challenge, product idea or technology requirement — we will respond using your preferred contact method."
      />
      <section className="bg-brand-surface py-20 lg:py-24">
        <div className="container-site grid items-start gap-12 lg:grid-cols-5">
          <Reveal className="lg:col-span-2">
            <div className="border border-border bg-white p-8 shadow-sm lg:p-10" data-testid="contact-info-card">
              <h2 className="text-xl font-semibold">Contact Information</h2>
              <ul className="mt-8 space-y-6">
                <li className="flex items-start gap-4">
                  <Mail className="mt-0.5 h-5 w-5 shrink-0 text-brand-red" strokeWidth={1.5} aria-hidden="true" />
                  <div>
                    <p className="font-heading text-xs font-semibold uppercase tracking-wider text-brand-graphite">
                      Email
                    </p>
                    <a
                      href={`mailto:${COMPANY.email}`}
                      className="mt-1 block text-sm text-brand-grey transition-colors duration-200 hover:text-brand-red"
                      data-testid="contact-email-link"
                    >
                      {COMPANY.email}
                    </a>
                  </div>
                </li>
                <li className="flex items-start gap-4">
                  <Globe className="mt-0.5 h-5 w-5 shrink-0 text-brand-red" strokeWidth={1.5} aria-hidden="true" />
                  <div>
                    <p className="font-heading text-xs font-semibold uppercase tracking-wider text-brand-graphite">
                      Website
                    </p>
                    <a
                      href={COMPANY.websiteUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="mt-1 block text-sm text-brand-grey transition-colors duration-200 hover:text-brand-red"
                      data-testid="contact-website-link"
                    >
                      {COMPANY.website}
                    </a>
                  </div>
                </li>
                <li className="flex items-start gap-4">
                  <Clock className="mt-0.5 h-5 w-5 shrink-0 text-brand-red" strokeWidth={1.5} aria-hidden="true" />
                  <div>
                    <p className="font-heading text-xs font-semibold uppercase tracking-wider text-brand-graphite">
                      Response
                    </p>
                    <p className="mt-1 text-sm leading-relaxed text-brand-grey">
                      We review every enquiry and respond through your preferred contact method.
                    </p>
                  </div>
                </li>
              </ul>
              <div className="mt-10 border-t border-border pt-6">
                <p className="font-heading text-sm font-semibold text-brand-graphite">
                  {COMPANY.name}
                </p>
                <p className="mt-1 text-sm text-brand-grey">{COMPANY.tagline}</p>
              </div>
            </div>
          </Reveal>
          <Reveal delay={120} className="lg:col-span-3">
            <EnquiryForm variant={isConsultation ? "consultation" : "contact"} />
          </Reveal>
        </div>
      </section>
    </main>
  );
};

export default Contact;
